module.exports = __webpack_public_path__ + "static/media/aec53dc9a104c98f334f6aa7424b6441.f8979d65.png";